import { Box, HStack } from '@chakra-ui/react';

const DEFAULT_IMAGES = [
  '/images/companion/companion-creator-1.webp',
  '/images/companion/companion-creator-3.webp',
  '/images/companion/companion-creator-4.webp',
];

interface PortraitClusterProps {
  images?: [string, string, string];
}

/**
 * Three round creator portraits in a staggered row (same circular avatar
 * language as the ready-step fan). The middle portrait is nudged up to break
 * strict alignment. Decorative only — images carry empty alt text.
 */
export const PortraitCluster: React.FC<PortraitClusterProps> = ({
  images = DEFAULT_IMAGES as [string, string, string],
}) => (
  <HStack gap="3" align="center">
    {images.map((src, index) => (
      <Box
        key={src}
        w="60px"
        h="60px"
        rounded="full"
        overflow="hidden"
        flexShrink={0}
        mt={index === 1 ? '-10px' : undefined}
      >
        <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </Box>
    ))}
  </HStack>
);
